import { Action } from "@ngrx/store";
import { IBenefitBalance, IBenefitTransaction } from "@edp-models/benefits-transaction.model";
import {
    CardType,
    Card,
    IFilter,
    IBenefitsCounter,
    ExclusiveBenefitsCardI,
    IBenefitsUserDetails,
    BenefitsDistricts,
    AvailableOfferFilter,
} from "@edp-models/benefits.model";

export enum EBenefitsActions {
    GetAvailable = "[Benefits] Get Cards",
    RefreshCards = "[Benefits] Refresh Cards",
    SetCards = "[Benefits] Set Available Cards",
    SetExclusiveBenefitsCards = "[Benefits] Set Exclusive Benefits Card",
    GetGeneratedCodes = "[Benefits] Get Generated Codes",
    SetGeneratedCodeCards = "[Benefits] Set Generated Codes Cards",
    SetFilters = "[Benefits] Set Filters",
    SetCardTypes = "[Benefits] Set Card Types",
    SetLoadedCards = "[Benefits] Set Loaded Cards",
    SetErrorBenefits = "[Benefits] Set error Benefits",
    GetErrorBenefits = "[Benefits] Get error Benefits",
    SelectFilters = "[Benefits] Select Filters",
    ReloadFilters = "[Benefits] Reload filters",
    ActiveShareModal = "[Benefits] Active Share Modal",
    GetCounterGeneratedCodes = "[Benefits] Get Counter Generated Codes",
    SetCounterGeneratedCodes = "[Benefits] Set Counter Generated Codes",
    GetCodeValidaty = "[Benefits] Get Code Validity",
    SetCodeValidaty = "[Benefits] Set Code Validity",
    GetBenefitsUsersDetails = "[Benefits] Get Benefits users details",
    SetBenefitsUsersDetails = "[Benefits] Set Benefits users details",
    GetTransactions = "[Benefits] Get Transactions",
    SetTransactions = "[Benefits] Set Transactions",
    SetBalance = "[Benefits] Set Balance",
    SetBenefitUserSelected = "[Benefits] Set Benefit User Selected",
    GetBenefitsDistricts = "[Benefits] Get Benefits Districts",
    SetBenefitsDistricts = "[Benefits] Set Benefits Districts",
    GetAvailableOffers = "[Benefits] Get Benefits Available Offers",
    SetAvailableOffers = "[Benefits] Set Benefits Available Offers",
    SetAvailableOffersFilter = "[Benefits] Set Benefits Available Offers Filter",
    GetAvailableOffersFilter = "[Benefits] Get Benefits Available Offers Filter",
    AddPageCounter = "[Benefits] Add Page Counter",
    SetPageCounter = "[Benefits] Set Page Counter",
    SetBenefitOnboarding = "[Benefits] Set Benefit Welcome",
}

export class GetAvailable implements Action {
    public readonly type = EBenefitsActions.GetAvailable;
}

export class RefreshCards implements Action {
    public readonly type = EBenefitsActions.RefreshCards;
}

export class GetBenefitsUsersDetails implements Action {
    public readonly type = EBenefitsActions.GetBenefitsUsersDetails;
}

export class SetBenefitsUsersDetails implements Action {
    public readonly type = EBenefitsActions.SetBenefitsUsersDetails;
    constructor(public payload: IBenefitsUserDetails[]) {}
}

export class SetCards implements Action {
    public readonly type = EBenefitsActions.SetCards;
    constructor(public payload: Card[]) {}
}

export class SetExclusiveBenefitsCards implements Action {
    public readonly type = EBenefitsActions.SetExclusiveBenefitsCards;
    constructor(public payload: ExclusiveBenefitsCardI[]) {}
}

export class GetGeneratedCodes implements Action {
    public readonly type = EBenefitsActions.GetGeneratedCodes;
}

export class SetGeneratedCodeCards implements Action {
    public readonly type = EBenefitsActions.SetGeneratedCodeCards;
    constructor(public payload: Card[]) {}
}

export class SetFilters implements Action {
    public readonly type = EBenefitsActions.SetFilters;
    constructor(public payload: IFilter[]) {}
}

export class SetCardTypes implements Action {
    public readonly type = EBenefitsActions.SetCardTypes;
    constructor(public payload: CardType[]) {}
}

export class SelectFilters implements Action {
    public readonly type = EBenefitsActions.SelectFilters;
}

export class SetLoadedCards implements Action {
    public readonly type = EBenefitsActions.SetLoadedCards;
    constructor(public payload: boolean) {}
}

export class SetErrorBenefits implements Action {
    public readonly type = EBenefitsActions.SetErrorBenefits;
    constructor(public payload: boolean) {}
}

export class GetErrorBenefits implements Action {
    public readonly type = EBenefitsActions.GetErrorBenefits;
}
export class ReloadFilters implements Action {
    public readonly type = EBenefitsActions.ReloadFilters;
    constructor(public payload: boolean) {}
}
export class ActiveShareModal implements Action {
    public readonly type = EBenefitsActions.ActiveShareModal;
    constructor(public payload: boolean) {}
}
export class GetCounterGeneratedCodes implements Action {
    public readonly type = EBenefitsActions.GetCounterGeneratedCodes;
}

export class SetCounterGeneratedCodes implements Action {
    public readonly type = EBenefitsActions.SetCounterGeneratedCodes;
    constructor(public payload: IBenefitsCounter) {}
}

export class GetCodeValidaty implements Action {
    public readonly type = EBenefitsActions.GetCodeValidaty;
    constructor(public payload: any) {}
}

export class SetCodeValidaty implements Action {
    public readonly type = EBenefitsActions.SetCodeValidaty;
    constructor(public payload: any) {}
}

export class GetTransactions implements Action {
    public readonly type = EBenefitsActions.GetTransactions;
    constructor(public payload: { pn: string }) {}
}

export class SetTransactions implements Action {
    public readonly type = EBenefitsActions.SetTransactions;
    constructor(public payload: IBenefitTransaction[]) {}
}

export class SetBalance implements Action {
    public readonly type = EBenefitsActions.SetBalance;
    constructor(public payload: IBenefitBalance) {}
}

export class SetBenefitUserSelected implements Action {
    public readonly type = EBenefitsActions.SetBenefitUserSelected;
    constructor(public payload: IBenefitsUserDetails) {}
}
export class GetBenefitsDistricts implements Action {
    public readonly type = EBenefitsActions.GetBenefitsDistricts;
}

export class SetBenefitsDistricts implements Action {
    public readonly type = EBenefitsActions.SetBenefitsDistricts;
    constructor(public payload: BenefitsDistricts[]) {}
}

export class GetAvailableOffers implements Action {
    public readonly type = EBenefitsActions.GetAvailableOffers;
    constructor(public payload: Card[]) {}
}

export class SetAvailableOffers implements Action {
    public readonly type = EBenefitsActions.SetAvailableOffers;
    constructor(public payload: Card[]) {}
}

export class SetAvailableOffersFilter implements Action {
    public readonly type = EBenefitsActions.SetAvailableOffersFilter;
    constructor(public payload: AvailableOfferFilter) {}
}

export class GetAvailableOffersFilter implements Action {
    public readonly type = EBenefitsActions.GetAvailableOffersFilter;
}

export class AddPageCounter implements Action {
    public readonly type = EBenefitsActions.AddPageCounter;
    constructor(public payload: { pn: string }) {}
}

export class SetPageCounter implements Action {
    public readonly type = EBenefitsActions.SetPageCounter;
}

export class SetBenefitOnboarding implements Action {
    public readonly type = EBenefitsActions.SetBenefitOnboarding;
}

export type BenefitsActions =
    | GetAvailable
    | SetCards
    | SetExclusiveBenefitsCards
    | SetGeneratedCodeCards
    | GetGeneratedCodes
    | GetBenefitsUsersDetails
    | SetBenefitsUsersDetails
    | SetFilters
    | SetCardTypes
    | SelectFilters
    | SetLoadedCards
    | ReloadFilters
    | ActiveShareModal
    | SetCounterGeneratedCodes
    | GetCounterGeneratedCodes
    | GetCodeValidaty
    | SetCodeValidaty
    | GetTransactions
    | SetTransactions
    | SetErrorBenefits
    | GetErrorBenefits
    | SetBalance
    | SetBenefitUserSelected
    | GetBenefitsDistricts
    | SetBenefitsDistricts
    | SetAvailableOffers
    | GetAvailableOffers
    | SetAvailableOffersFilter
    | GetAvailableOffersFilter
    | SetBenefitOnboarding
    | SetPageCounter
    | AddPageCounter;
